import { render } from "./AddTypeDocumentPage.vue?vue&type=template&id=642bd39d&ts=true"
import script from "./AddTypeDocumentPage.vue?vue&type=script&lang=ts"
export * from "./AddTypeDocumentPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__